import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AUTH_TYPE_KEY, SESSION_ID_KEY } from '../../models/consts';
import { canonicalUuid } from '../technical-identifiers';

export const registrationGuard = () => {
  const router = inject(Router);
  const authType: string | null = localStorage.getItem(AUTH_TYPE_KEY);
  if (authType && authType === 'registration_started') {
    return true;
  }
	const session_id = canonicalUuid(localStorage.getItem(SESSION_ID_KEY));
  return router.createUrlTree(['/login'], {
    queryParams: {
      session_id: session_id,
    },
  });
};
